export const baseUrl = "https://timertaleh.herokuapp.com/api/v1/"
export const imgUrl = "https://timertaleh.herokuapp.com/img/"